import '../../../app.css';
import '../../../title/title.css';
import '../../game.css';

const React = require('react');
const styles = require('../../game.style').default;
const assets = require('../../../../assets').default;
const ModalWindow = require('../../../../core/modal').default;
const { getStageName } = require('../../../../core/stageData').default;
const { sound, soundType } = require('../../../../core/sound').default;
// ============================

export default class stageStartComponent extends React.Component {
    renderContents() {
        const { gameState: { arrivalStage } } = this.props;
        return (
            <div style={styles.modalStyle}>
                <div className="tips-layout">
                    <div className="stage-start-title">
                        <div>ステージ {arrivalStage}</div>
                        <div>{getStageName(arrivalStage)}</div>
                    </div>

                    <div className="tips-button">
                        <div className="btn-radius-solid" onClick={() => {
                            this.props.handleStartClick()
                        }}>スタート！</div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return <ModalWindow
            isModalOpen={this.props.isModalOpen}
            isCloseOutOfArea={false}
            contents={this.renderContents()}
        />
    }
}